// Invisible anti-spam field: humans never see or fill it, naive bots do.
export default function Honeypot({ value, onChange }) {
  return (
    <input
      type="text"
      name="website"
      value={value || ""}
      onChange={(e) => onChange(e.target.value)}
      autoComplete="off"
      tabIndex={-1}
      aria-hidden="true"
      style={{ position: "absolute", left: "-9999px", width: 1, height: 1, opacity: 0 }}
    />
  );
}
